<template>
  <div class="container push-top">
    <loading-indicator v-if="templates === false"></loading-indicator>

    <div class="no-templates" v-if="templates !== false && templates.length <= 0">
      <img src="/images/sad.png">
      <h3>{{ $t('templates.no_templates_msg_title') }}</h3>
      <p>{{ $t('templates.no_templates_msg_body') }}</p>
      <router-link to="/a/template/new" class="button is-primary is-large">
        {{ $t('templates.create_template') }}
      </router-link>
    </div>

    <div class="columns" v-if="templates.length > 0">
      <div class="column is-12">

        <router-link class="button is-primary is-medium is-pulled-right push-right" to="/a/template/new">
          {{ $t('templates.new_template') }}
        </router-link>

        <h2 class="is-pulled-left">{{ $t('navigation.templates') }}</h2>
      </div>
    </div>

    <div class="container">
      <div class="columns">
        <div class="column is-12">
          <ul class="templates">
            <template-card :template="template" v-for="template in templates" :key="template.id" @delete="deleteTemplate"></template-card>
          </ul>
        </div>
      </div>
    </div>

  </div>
</template>

<script>
import TemplateCard from './partials/template-card.vue';
import API from 'mixins/api';

export default {
  mixins: [API],
  components: {
    TemplateCard,
  },
  beforeMount() {
    this.api().fetchTeamTemplates()
      .then(templates => this.templates = templates );
  },
  data () {
    return {
      templates: false,
    }
  },
  methods: {
    deleteTemplate(template) {
      this.templates = _.without(this.templates, template);
    }
  }
}
</script>

<style lang="scss" scoped>
@import "resources/assets/sass/layout/_variables";

.no-templates {
  width: 400px;
  background: $white;
  text-align: center;
  padding: 40px;
  border-radius: 2px;
  display: block;
  margin: 200px auto;
  border: 1px solid lighten($mutedblue, 12%);
  img {
    width: 60px;
    display: block;
    margin: 0 auto 26px;
  }
  h3 {
    font-size: 16px;
    text-transform: uppercase;
    font-weight: 600;
    margin: 0 0 20px;
    letter-spacing: 1px;
  }
  p {
    margin-bottom: 25px;
  }
}

a.button {
  margin-top: -4px;
}

ul.templates {
  display: flex;
  flex-wrap: wrap;
}

</style>



// WEBPACK FOOTER //
// Templates.vue?66e869be